module.exports = __webpack_public_path__ + "static/media/Bettdecke_100x135.623698c2.png";